import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import GalleryGrid from '../../components/GalleryGrid/GalleryGrid';
import GalleryItem from '../../components/GalleryItem/GalleryItem';
import { useFacility } from '../../contexts/FacilityContext';
import propertyImg1 from '../../assets/images/Property_1.webp';
import propertyImg2 from '../../assets/images/Property_2.webp';
import propertyImg3 from '../../assets/images/Property_3.webp';

import styles from './HomePage.module.css';

const heroImages = [
    propertyImg1,
    propertyImg2,
    propertyImg3
];


const highlightImages = [
    '/images/Landing_page/Service_day_1.webp',
    '/images/Landing_page/Service_day_2.webp',
    '/images/Landing_page/Service_day_3.webp',
];

const HomePage = () => {
    const { facilityData, facilityLoading, facilityError } = useFacility();
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    // Auto-rotate images
    useEffect(() => {
        const timer = setTimeout(() => {
            setCurrentImageIndex(prevIndex => (prevIndex + 1) % heroImages.length);
        }, 5000);
        return () => clearTimeout(timer);
    }, [currentImageIndex]);

    const nextImage = () => {
        setCurrentImageIndex(prevIndex => (prevIndex + 1) % heroImages.length);
    };

    const prevImage = () => {
        setCurrentImageIndex(prevIndex => (prevIndex - 1 + heroImages.length) % heroImages.length);
    };

    if (facilityLoading) {
        return <div className={styles.loader}>Loading facility details...</div>;
    }
    if (facilityError) {
        return <div className={styles.error}>{facilityError}</div>;
    }

    return (
        <div>
            <section id="home" className={styles.heroSection}>
                {heroImages.map((img, index) => (
                    <div
                        key={index}
                        className={`${styles.heroBackground} ${index === currentImageIndex ? styles.active : ''}`}
                        style={{ backgroundImage: `url(${img})` }}
                        aria-hidden="true"
                    ></div>
                ))}

                <button
                    className={`${styles.arrowButton} ${styles.leftArrow}`}
                    onClick={prevImage}
                    aria-label="Previous background image"
                >
                    &#10094;
                </button>
                <button
                    className={`${styles.arrowButton} ${styles.rightArrow}`}
                    onClick={nextImage}
                    aria-label="Next background image"
                >
                    &#10095;
                </button>
                <div className={styles.heroContent}>
                    {/* <h1>{facilityData?.name || "Highview House"}</h1> */}
                    <p>{facilityData?.description || "Meeting facilities for small conferences or retreats available to the churches in the Southeast."}</p>
                    <Link to="/request-reservation" className={styles.heroButton}>Explore Availability</Link>
                </div>
                {/* This is now a simple <a> tag. The browser will handle the smooth scroll and offset. */}
                <a
                    href="#home-about-section"
                    className={styles.scrollLinkWrapper}
                    aria-label="Scroll to content"
                >
                    <div className={styles.scrollIndicator}><span></span></div>
                </a>
            </section>

            <section id="home-about-section" className={`${styles.contentSection} ${styles.lightSection}`}>
                <h2>Highview House</h2>
                <p className={styles.introParagraph}>
                    Welcome to {facilityData?.name || 'Highview House'}, operated by the Church in Atlanta. A meeting place for small conferences or retreats available to the churches in the Southeast.
                </p>
                <div className={styles.locationInfo}>
                    <h3>Our Location</h3>
                    <div className={styles.mapContainer}>
                        <iframe
                            width="100%"
                            height="450"
                            style={{ border: 0 }}
                            loading="lazy"
                            allowFullScreen
                            title="Homepage location map"
                            src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyDNlc0KsbVBFub3bSXHvXX_5iYRMsvZCz0&q=2375+Highview+Road,Young+Harris,Georgia`}>
                        </iframe>
                    </div>
                </div>
                <Link to="/about" className={styles.viewMoreButton}>
                    More About Us &rarr;
                </Link>
            </section>

            <section id="home-gallery-section" className={`${styles.contentSection} ${styles.lightSection} ${styles.highlightsBackground}`}>
                <h2>Highlights</h2>
                <p className={styles.introParagraph}>
                    Photos of Highview Service Day
                </p>
                <GalleryGrid>
                    {highlightImages.map((imgSrc, index) => (
                        <GalleryItem
                            key={index}
                            src={imgSrc}
                            alt={`Highlight Image ${index + 1}`}
                        />
                    ))}
                </GalleryGrid>
                <Link to="/gallery" className={styles.viewMoreButton}>
                    View Full Gallery &rarr;
                </Link>
            </section>
        </div>
    );
};

export default HomePage;
